export const BOX_BORDER = 1;
export const BOX_INDICATOR_BORDER = 3;
export const BOX_INDICATOR_SIZE = 20;
